module.exports = {
  // 'font-family': 'serif'
  'font-weight': 'normal',
  'font-style': 'normal',
  'font-stretch': 'normal',
  content: 'normal',
  quotes: '"«" "»" "‹" "›" "‘" "’" "\'" "\'" "\\"" "\\""', // Wide default set to account for browser differences
  'list-style-type': 'none',
  display: 'inline',
  'animation-name': 'none',
  'animation-timing-function': 'ease',
  'text-transform': 'none',
  'transition-property': 'all',
  'transition-duration': '0s',
  'counter-increment': 'none',
  'counter-reset': 'none',
  'counter-set': 'none',
  'white-space': 'normal',
  'font-variation-settings': 'normal',
};
